<template>
  <div id="app" :class="mobile && 'mb'">
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>


<script>
export default {
  computed: {},
  data() {
    return {
      mobile: false,
    };
  },
  methods: {
    check() {
      let width = window.screenWidth || document.body.clientWidth;

      if (width < 768) {
        this.mobile = true;
      } else {
        this.mobile = false;
      }
    },
  },
  mounted() {
    this.check();
    window.addEventListener("resize", () => {
      this.check();
    });
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* height: 100vh; */
  min-width: 320px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
